<template>
  <div>
    <div class="list">
      <div v-for="(item, index) in list" :key="index" :class="item.status == 'line' ? 'line' : computeClassName(item.status)" >
        <div v-if="item.status != 'line'">
            {{item.text}}
        </div>
        <div v-if="item.status == 'line'"></div>
      </div>
    </div>
  </div>
</template>
<script>
	export default {
    name: 'job-delivery-status',
    props: {
      status: {
        type: String,
        default: () => ""
      }
    },
    data (){
      return {
        list: [
          { status: 'delivery', active: false , text: '已投递'},
          { status: 'line' },
          { status: 'viewed', active: false, text: '已查看' },
          { status: 'line' },
          { status: 'communicated', active: false , text: '沟通中'},
          { status: 'line' },
          { status: 'appointment', active: false, text: '已约面' }]
      }
    },
    methods:{
      computeClassName(args){
        if(args == this.status && args != 'unsuited'){
          return 'item active';
        }else if(args == this.status && args == 'unsuited'){
          return 'item unsuited'
        }else {
          return 'item'
        }
      }
    },
    mounted(){
      let list= this.list;
      if(this.status == 'unsuited'){
        list[6]['status'] = 'unsuited';
        list[6]['text'] = '不合适';
        list[6]['active'] = true;
      }
      let i  = list.findIndex(item => item.status == status);
      if(i > -1){
        list.forEach((item, index) => {
          if(index <= i){
            item['active'] = true;
          }
        })
      }
      this.list = JSON.parse(JSON.stringify(list));
    }
  }
</script>
<style lang="scss" scoped>
  .list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-top: 1px dashed #ECECEC;
    padding-top: 12px;
    margin-top: 14px;
    padding-bottom: 2px;
    .item {
      width: 52px;
      height: 22px;
      text-align: center;
      line-height: 22px;
      background: #F9F9F9;
      font-size: 12px;
      border-radius: 12px;
      color: #BCBCBC;
    }
    .item.active{
      background: #F5F8FF;
      color: #4183FF
    }
    .item.unsuited{
      background: #FFF6F4;
      color: #FF6644;
    }
    .line {
      flex:1;
      height: 1px;
      background: #ECECEC;
      margin-left: 4px;
      margin-right: 4px;
    }
  }
</style>